import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  success: null,
};

const resetPasswordRequestSlice = createSlice({
  name: "resetPasswordRequest",
  initialState: initialState,
  reducers: {
    resetPasswordRequestStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = null;
    },
    resetPasswordRequestSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    resetePasswordRequestFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    clearResetPasswordRequestState() {
      return initialState;
    },
  },
});

export const {
  resetPasswordRequestStart,
  resetPasswordRequestSuccess,
  resetePasswordRequestFailure,
  clearResetPasswordRequestState,
} = resetPasswordRequestSlice.actions;
export default resetPasswordRequestSlice.reducer;
